var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelTestingAndComparison(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.525 21.675C10.8 24.425 10.5 25.725 10.5 25.975C10.5 26.175 12.15 26.25 16 26.25C19.85 26.25 21.5 26.175 21.5 25.975C21.5 25.725 21.2 24.425 20.475 21.675L20.225 20.75H16H11.775L11.525 21.675ZM17 23.5V24.5H16H15V23.5V22.5H16H17V23.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74922 28.55C9.74922 28.725 9.67422 29.125 9.59922 29.425L9.44922 30H15.9992H22.5492L22.3992 29.45C22.3242 29.125 22.2492 28.725 22.2492 28.55C22.2492 28.325 20.8242 28.25 15.9992 28.25C11.1742 28.25 9.74922 28.325 9.74922 28.55Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.8867,
    width: 24,
    height: 2,
    transform: "rotate(-14.1967 4 18.8867)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3323 3.88959C19.2763 4.37398 18.4141 4.80025 18.4141 4.839C18.4141 4.92619 22.2117 6.67969 22.3958 6.67969C22.5508 6.67969 26.4453 4.9165 26.4453 4.839C26.4453 4.76149 22.5508 2.99831 22.3861 2.99831C22.3086 2.99831 21.3785 3.39551 20.3323 3.88959Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 7.72953V10.0256L19.8657 11.004L21.997 11.9922V9.68648V7.38077L21.5417 7.18702C21.2801 7.08045 20.321 6.63481 19.4104 6.20854L17.7344 5.43351V7.72953Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8854 6.42949L22.7734 7.40796V9.70398V12L24.4494 11.225C25.3601 10.7987 26.3192 10.3531 26.5808 10.2465L27.0361 10.0527V7.73735C27.0361 6.45855 27.0264 5.42195 27.0167 5.43164C26.9973 5.44133 26.0382 5.88697 24.8854 6.42949Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59788 7.88959C5.54191 8.37398 4.67969 8.80025 4.67969 8.839C4.67969 8.92619 8.47732 10.6797 8.66139 10.6797C8.8164 10.6797 12.7109 8.9165 12.7109 8.839C12.7109 8.76149 8.8164 6.99831 8.65171 6.99831C8.5742 6.99831 7.64417 7.39551 6.59788 7.88959Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7295V14.0256L6.13133 15.004L8.26265 15.9922V13.6865V11.3808L7.80732 11.187C7.54575 11.0804 6.58666 10.6348 5.676 10.2085L4 9.43351V11.7295Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.151 10.4295L9.03906 11.408V13.704V16L10.7151 15.225C11.6257 14.7987 12.5848 14.3531 12.8464 14.2465L13.3017 14.0527V11.7373C13.3017 10.4586 13.292 9.42195 13.2823 9.43164C13.263 9.44133 12.3039 9.88697 11.151 10.4295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTestingAndComparison);
export default __webpack_public_path__ + "static/media/ModelTestingAndComparison.3c75d3aecaba563dbc0e2129cf11ba20.svg";
export { ForwardRef as ReactComponent };